<template>
  <Dialog :visible="active" :closable="false" :modal="true" :style="{ maxWidth: '90%', width: '80%', minWidth: '600' }">
    <template #header>
      <h2 class="title is-5 w100">{{ schedule.name }}</h2>
      <Button @click="close" class="p-button-text floatRight">{{ $t("Button.close") }}</Button>
    </template>

    <BracketGenerator :teams="teams" :games="games" />
  </Dialog>
</template>

<script>
import BracketGenerator from "@/components/bracket/BracketGenerator.vue";

export default {
  components: { BracketGenerator },
  props: ["active", "items", "close", "schedule"],
  computed: {
    games() {
      return this.items.map(i => i.game);
    },
    teams() {
      return this.games
        .filter(g => g.home_name !== "TBD")
        .map(g => [g.home_name, g.visitor_name])
        .flat()
        .filter((value, index, array) => array.indexOf(value) === index);
    },
  },
};
</script>
